import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { RoleTargetKpisService } from 'src/app/assabil-sales/services/role-target-kpis-service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Visit } from 'src/app/assabil-kernel/models/entities/master-data/visit-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';

@Component({
  selector: 'role-target-kpis-widget',
  templateUrl: './role-target-kpis-widget.component.html',
  styleUrls: ['./role-target-kpis-widget.component.scss']
})


export class RoleTargetKpisWidgetComponent implements OnInit {
  
  @Input() role                 : Role;
  @Input() clickedRoleContainer : Role[];


  @Output() onRoleClicked   = new EventEmitter<any>();
  @Output() onKpiClicked    = new EventEmitter<Role>();


  ngOnInit(){}

  constructor( 
    public    leanUtilsService    : LeanUtilsService,
    protected roleTargetKpisService : RoleTargetKpisService
   ) {
  }


  roleClicked(passTrough : boolean){
    if (! passTrough) {
      this.clickedRoleContainer[0] = this.role;
    }
    this.onRoleClicked.emit(null);  
  }

  kpiClicked(role : Role){
    this.onKpiClicked.emit(role);  
  }

}
